import PairShareResult from "./PairShareResult";
import { useToolkitPairshareStore } from "src/pods/pairshare/toolkitPairshareStore";
import { displayClose } from "src/pods/realtime";
import PresentationPage from "src/shared/components/PresentationPage";
import { dispatchToolkitReduxAction } from "src/state/toolkitReduxStore";

export default function PairShareResultContainer() {
  const { question } = useToolkitPairshareStore();

  return (
    <PresentationPage variant="pairshare" onRequestHide={() => dispatchToolkitReduxAction(displayClose())}>
      <PairShareResult question={question} />
    </PresentationPage>
  );
}
